An array of formatted position profile descriptions.

At least one AdvertisementDetails description must be provided.
